import React from 'react';

const Select = ({ label, options = [], error, className = '', placeholder = 'Seleccionar...', ...props }) => (
  <div className={className}>
    {label && <label className="block text-sm font-medium text-slate-300 mb-2">{label}</label>}
    <select
      className={`
        w-full bg-slate-700/50 border rounded-xl py-2.5 px-4 text-white 
        focus:outline-none focus:border-emerald-500 transition-colors 
        appearance-none cursor-pointer
        ${error ? 'border-rose-500' : 'border-slate-600'}
      `}
      {...props}
    >
      <option value="" className="bg-slate-800">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value} className="bg-slate-800">
          {opt.label}
        </option>
      ))}
    </select>
    {error && <p className="mt-1 text-sm text-rose-400">{error}</p>}
  </div>
);

export default Select;
